export const framedModalPath = 'assets/pages/framed-modal.html';
export const closeModalPath = 'assets/pages/close-modal.html';
export const maxReadyTimeout = 10000;
export const fullSizeWidthBreakpoint = 760;
